function setupClipboardCopy(selector, attribute) {
  document.querySelectorAll(selector).forEach(function (button) {
    button.addEventListener('click', function () {
      const code = this.getAttribute(attribute);
      if (!code) return;

      navigator.clipboard.writeText(code).then(() => {
        const originalText = this.textContent;
        this.textContent = 'Copied!';
        setTimeout(() => {
          this.textContent = originalText;
        }, 2000);
      }).catch((err) => {
        console.error('Failed to copy:', err);
      });
    });
  });
}

// Initialize both sets of buttons with different attributes
setupClipboardCopy('.copy-clipboard', 'data-product-code');
setupClipboardCopy('.copy-clip', 'data-code');

